import { render, staticRenderFns } from "./CartMenu.vue?vue&type=template&id=b2f878c2&scoped=true"
import script from "./CartMenu.vue?vue&type=script&lang=js"
export * from "./CartMenu.vue?vue&type=script&lang=js"
import style0 from "./CartMenu.vue?vue&type=style&index=0&id=b2f878c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f878c2",
  null
  
)

export default component.exports